import axios, { AxiosRequestConfig } from "axios";
import AuthProvider from "../../../../../common/authentication/authService";
import { GET_XTOKEN } from "../../../../../common/apiEndPoint/apiEndPoint";
import config from "../../../../../common/authentication/config";
import { siteIdStatic } from "../../file-management/store/file-management.service";
import queryString from "query-string";

let controller = new AbortController(); // Declare at module level

export const apiClient = axios.create({
  baseURL: config?.API_SERVICE,
});

export const resetAbortController = () => {
  controller.abort(); // Cancel all ongoing requests
  controller = new AbortController(); // Create a new controller for future requests
};

export const getControllerSignal = () => controller.signal;

const orgId = config?.ACADEMY_TENANT_ID;
const orgName = config?.ACADEMY_ORGNAME;

apiClient.interceptors.request.use(
  async (config: any) => {
    if (config && config.headers) {
      if (config.url !== undefined) {
        const key = "access_token";
        // Try to obtain token from AuthProvider.getAccessToken(), fallback to localStorage
        let token: any = await localStorage[key];
       
        // Safely get XSRF token via AuthProvider.getCookie if available
        let xToken: any;
        try {
          const auth = AuthProvider();
          xToken = auth && typeof auth.getCookie === "function" ? await auth.getCookie("XSRF-TOKEN") : undefined;
        } catch (e) {
          xToken = undefined;
        }

        if (!config.headers["Authorization"] && token) {
          config.headers["Authorization"] = "Bearer " + token;
        }
        if (xToken) {
          config.headers["X-XSRF-TOKEN"] = xToken;
        }
        config.headers["Accept"] = "application/json;version=36.3";
        config.headers["siteid"] = siteIdStatic;
        config.headers["orgId"] = orgId;
        config.headers["tenantId"] = orgId;
        config.headers["OrgName"] = orgName;
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (resp) => resp,
  async (err) => {
    if (!err.response) {
      return Promise.reject(err);
    }
    const status = err.response?.status;
    const xToken = await AuthProvider().getCookie("XSRF-TOKEN");
    if (
      status === 400 &&
      err.response?.statusText == "Bad Request" &&
      (xToken == "" || xToken == undefined)
    ) {
      const key = "access_token";
      const token = await localStorage[key];
      await axios.get(`${GET_XTOKEN}`, {
        headers: {
          Authorization: "Bearer " + token, // the token is a variable which holds the token
        },
      });
      return axios(err.response.config);
    } else if (status === 401) {
      await AuthProvider().getRefreshToken();

      return axios(err.response.config);
    }

    if (status === 400) {
      return Promise.reject(err);
    }
    return err.response;
  }
);

